<section class="container-background container-fluid content">
  <div class="row">
    <h2 class="page-title col-12">{{ contactId ? "Modification du contact" : "Nouveau contact" }}</h2>
  </div>
  <div class="m-2 p-4 bg-white rounded">
    <form [formGroup]="form" (ngSubmit)="save()">

      <div class="row">
        <div class="col-12 d-flex justify-content-center mb-4">
          <app-circle-image-input [src]="$safeNavigationMigration(image?.current)" defaultSrc="assets-front/images/avatar-default.png" (update)="updateImage($event)" (delete)="deleteImage($event)"></app-circle-image-input>
        </div>
      </div>

      <div class="row">
        @if (form.get('nom'); as control) {
          <div class="mb-3 col-12 col-lg-6">
            <label for="nom">Nom *</label>
            <input class="form-control" id="nom" type="text" formControlName="nom" [ngClass]="{'is-invalid': !control.valid}" placeholder="Jean Dupond"/>
            <div class="invalid-feedback">{{ control.errors }}</div>
          </div>
        }

        @if (form.get('metier'); as control) {
          <div class="mb-3 col-12 col-lg-6">
            <label for="metier">Métier</label>
            <input class="form-control" id="metier" type="text" formControlName="metier" [ngClass]="{'is-invalid': !control.valid}" placeholder="Chauffagiste"/>
            <div class="invalid-feedback">{{ control.errors }}</div>
          </div>
        }

        @if (form.get('email'); as control) {
          <div class="mb-3 col-12 col-lg-6">
            <label for="email">Email</label>
            <input class="form-control" id="email" type="text" formControlName="email" [ngClass]="{'is-invalid': !control.valid}" placeholder="jdupond-chauffagiste@gmail.com"/>
            <div class="invalid-feedback">{{ control.errors }}</div>
          </div>
        }

        @if (form.get('numeroTelephone'); as control) {
          <div class="mb-3 col-12 col-lg-6">
            <label for="numeroTelephone">Téléphone</label>
            <input class="form-control" id="numeroTelephone" type="text" formControlName="numeroTelephone" [ngClass]="{'is-invalid': !control.valid}" placeholder="0765432100"/>
            <div class="invalid-feedback">{{ control.errors }}</div>
          </div>
        }

        @if (form.get('site'); as control) {
          <div class="mb-3 col-12 col-lg-6">
            <label for="site">Site web</label>
            <input class="form-control" id="site" type="text" formControlName="site" [ngClass]="{'is-invalid': !control.valid}"/>
            <div class="invalid-feedback">{{ control.errors }}</div>
          </div>
        }
      </div>

      <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-bottom justify-content-center">
        <a class="btn btn-light" routerLink="/contacts">Annuler</a>&nbsp;
        <button type="submit" class="btn btn-blue" [disabled]="loaderService.loading | async" matomoClickCategory="Contacts" matomoClickAction="click" matomoClickName="contact_edit_enregistrer">Enregistrer</button>
      </nav>
    </form>
  </div>
</section>
